
        import '/home/builduser/work/c1dd1064fea009a6/santa-editor/packages/quickEdit/components/styles/buttonDesignEntryPoint.scss.css.virtualfile';
        module.exports = {"buttonDesignEntryPoint":"_buttonDesignEntryPoint_1juf4_7","link":"_link_1juf4_10"};